<template>
 <!-- 
   :group="{ name: 'g1' }" 
   handle=".handle"
 -->
  <draggable 
    class="dragArea mt-1" 
    tag="ul" 
    :group="{ name: 'g1' }"    
    handle=".handle"
    ghost-class="ghost"
    :delivery_time_criteria_keys="delivery_time_criteria_keys"


    :list="list" 
    :value="value"
    @input="emitter"
    v-bind="dragOptions"
    
    :component-data="getComponentData()"
    >    
      
      <li class="element" v-for="el, index in realValue" :key="el.id">
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12 text text-primary">
                <h5><i class="fa fa-info" aria-hidden="true"></i> {{el.description}}</h5>
              </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="input-group">
                        <span class="input-group-text handle"><i class="fa fa-arrows-alt" aria-hidden="true"></i></span>
                        <input type="hidden" class="form-control" @change="el.validateError.key.error=false" v-model="el.key" readonly>
                        <input type="text" class="form-control" @change="el.validateError.value.error=false" v-model="el.value" placeholder="value">
                    </div>
                    <span class="help-block text text-danger" v-bind:class="{'d-block':el.validateError.value.error,'d-none':!el.validateError.value.error}"><small>{{el.validateError.value.message}}</small> </span>
                </div>

                <div class="col-md-3">
                    <div class="form-group">
                      <input type="text" class="form-control" @change="el.validateError.start_active.error=false" v-model="el.start_active"  placeholder="วันเวลาเริ่มใช้งาน yyyy-mm-dd hh:ii:ss">
                      <span class="help-block text text-danger" v-bind:class="{'d-block':el.validateError.start_active.error,'d-none':!el.validateError.start_active.error}"><small>{{el.validateError.start_active.message}}</small> </span>
                    </div>
                </div>

                <div class="col-md-3">
                    <div class="form-group">                      
                      <input type="text" class="form-control" @change="el.validateError.end_active.error=false" v-model="el.end_active"  placeholder="วันเวลาสิ้นสุดการใช้งาน yyyy-mm-dd hh:ii:ss">
                      <span class="help-block text text-danger" v-bind:class="{'d-block':el.validateError.end_active.error,'d-none':!el.validateError.end_active.error}"><small>{{el.validateError.end_active.message}}</small> </span>
                    </div>
                </div>

                <div class="col-md-9">
                    <div class="form-group">
                        <input type="text" class="form-control" @change="el.validateError.message.error=false" v-model="el.message" placeholder="ข้อความที่จะตอบกลับผู้ใช้ หรือตอบให้ frontend">
                        <span class="help-block text text-danger" v-bind:class="{'d-block':el.validateError.message.error,'d-none':!el.validateError.message.error}"><small>{{el.validateError.message.message}}</small> </span>
                    </div>
                </div>

                <div class="col-md-2">
                    <div class="form-group">
                        <select class="form-control" name="delivery_time_criteria_status" @change="el.validateError.enabled.error=false" v-model="el.enabled">
                            <option value="">สถานะ</option>
                            <option :value=1>เปิดใช้งาน</option>
                            <option :value=0>ปิดการใช้งาน</option>
                        </select>
                        <span class="help-block text text-danger" v-bind:class="{'d-block':el.validateError.enabled.error,'d-none':!el.validateError.enabled.error}"><small>{{el.validateError.enabled.message}}</small></span>
                    </div>
                </div>                

                <div class="col-md-1">
                    <div class="input-group">
                        
                        <span class="input-group-text text text-danger" v-on:click="deleteClicked(index)"><i class="fa fa-trash" aria-hidden="true"></i></span>
                    </div>
                    <!-- <span class="help-block text text-danger" v-bind:class="{'d-block':el.validateError.value.error,'d-none':!el.validateError.value.error}"><small>{{el.validateError.value.message}}</small> </span> -->
                </div>

            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 pl-5">
            <nested-menu-draggable class="sub-items" :list="el.children" :delivery_time_criteria_keys="delivery_time_criteria_keys" />
          </div>
        </div>
      </li>
      
  </draggable>
</template>
<script>
import draggable from "vuedraggable"; //https://github.com/SortableJS/Vue.Draggable
export default {
  name: "nested-menu-draggable",
  methods: {
    resetErrorStatus(el){
      el = false;
    },
    emitter(value) {
      this.$emit("input", value);
    },
    deleteClicked(index){
      this.list.splice(index, 1);
    },handleChange() {
      // console.log('changed');
    },
    inputChanged(value) {
      // console.log(value)
      this.activeNames = value;
    },
    getComponentData() {
      return {
        on: {
          change: this.handleChange,
          input: this.inputChanged
        },
        attrs:{
          wrap: true
        },
        props: {
          value: this.activeNames
        }
      };
    }    
  },
  components: {
    draggable  
  },
  computed: {
    dragOptions() {
      return {
        animation: 1,
        group: "description",
        disabled: false,
        ghostClass: "g1"
      };
    },
    // this.value when input = v-model
    // this.list  when input != v-model
    realValue() {
      // return this.list;
      // return this.value;
      return this.value ? this.value : this.list;
    }
  },  
  props: {
    list: {
      required: false,
      // type: Array
    },
    value: {
      required: false,
      // type: Array
    },
    delivery_time_criteria_keys: {
      required: false,
      // type: Object
    }
  }
};
</script>
<style scoped>
.dragArea {  
  border-radius: 0.25rem;
 
  min-height: 30px;
  outline: 1px #ddd solid;  
 
  
}
span.handle{
  cursor:move;  
}
.dragArea .element {
  list-style-type:none;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: 5px;
}
.sub-items{
  min-height: 30px;
  margin-top:inherit;
}

/* .item-container {
  max-width: 20rem;
  margin: 0;
}
.item {
  padding: 1rem;
  border: solid black 1px;
  background-color: #fefefe;
}
.item-sub {
  margin: 0 0 0 1rem;
} */

</style>